import _ from 'lodash'
import type {ComponentExportStructure} from '@wix/document-services-types'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import {omitUndefined} from '@wix/document-manager-utils'

export const pack: DecorationSingleComponentPluginFunction = (vectorImage: ComponentExportStructure) => {
    if (vectorImage.data?.svgId) {
        vectorImage.src = vectorImage.data.svgId
        delete vectorImage.data.svgId
    }

    if (vectorImage.data?.title) {
        vectorImage.title = vectorImage.data.title
        delete vectorImage.data.title
    }

    if (vectorImage.data?.alt) {
        vectorImage.alt = vectorImage.data.alt
        delete vectorImage.data.alt
    }

    if (vectorImage.props?.displayMode) {
        vectorImage.displayMode = vectorImage.props.displayMode
        delete vectorImage.props.displayMode
        if (_.isEmpty(vectorImage.props)) {
            delete vectorImage.props
        }
    }

    const {shapeStyle} = vectorImage.design?.default ?? {}
    if (shapeStyle) {
        const stroke = omitUndefined({
            color: shapeStyle.stroke,
            opacity: shapeStyle.strokeOpacity,
            width: shapeStyle.strokeWidth,
            enabled: shapeStyle.enableStroke
        })

        delete shapeStyle.stroke
        delete shapeStyle.strokeOpacity
        delete shapeStyle.strokeWidth
        delete shapeStyle.enableStroke

        if (!_.isEmpty(stroke)) {
            shapeStyle.stroke = stroke
        }
    }
}
